<template>
    <div>
        <div class="mb-8">
            <h1 class="text-2xl font-semibold text-gray-800">{{ $t('account.notifications.title') }}</h1>
            <p class="text-normal text-gray-400 mt-1">{{ $t('account.notifications.description') }}</p>
        </div>

        <div v-if="loading" class="bg-white rounded-xl border border-gray-200 p-6">
            <div class="animate-pulse h-8 bg-gray-100 rounded w-full"></div>
        </div>

        <div v-else class="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
            <div class="flex items-center justify-between px-6 py-4">
                <div>
                    <p class="text-normal font-medium text-gray-800">{{ $t('account.notifications.emailLabel') }}</p>
                    <p class="text-sm text-gray-400 mt-0.5">{{ $t('account.notifications.emailDescription') }}</p>
                </div>
                <AppToggle v-model="emailEnabled" @update:modelValue="save" />
            </div>
        </div>

        <p v-if="saveError" class="mt-3 text-xs text-error-500">{{ $t('errors.unknown') }}</p>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useToast } from 'vue-toastification';
import { useI18n } from 'vue-i18n';
import AppToggle from '@/components/ui/AppToggle.vue';
import { notificationsApi } from '@/api/notifications';

const toast = useToast();
const { t } = useI18n();

const loading = ref(true);
const saving = ref(false);
const saveError = ref(false);
const emailEnabled = ref(false);

onMounted(async () => {
    try {
        const prefs = await notificationsApi.getPreferences();
        emailEnabled.value = prefs.emailEnabled;
    } catch {
        // Leave defaults
    } finally {
        loading.value = false;
    }
});

async function save() {
    if (saving.value) return;
    saving.value = true;
    saveError.value = false;
    try {
        await notificationsApi.updatePreferences({ emailEnabled: emailEnabled.value });
        toast.success(t('account.notifications.saved'));
    } catch {
        saveError.value = true;
        toast.error(t('errors.unknown'));
    } finally {
        saving.value = false;
    }
}
</script>
